import { StyleSheet } from 'react-native'
import { DS } from '../../../design-system'
import { ChapterModelType } from '../../../models/api-store'
import { Chapter } from '../components/Chapter'
import { observer } from 'mobx-react-lite'

interface ChaptersProps {
  chapters: ChapterModelType[]
  currentChapter: ChapterModelType
  onChapterPress: (_id: string | undefined | null) => void
  isVideoPlaying: boolean
  isUserSubscriber: boolean
}

export const Chapters = observer(
  ({ chapters, currentChapter, isVideoPlaying, onChapterPress, isUserSubscriber }: ChaptersProps) => {
    const isCurrentChapter = (_id: string | undefined | null) => {
      if (_id) {
        return _id === currentChapter._id
      }

      return false
    }

    return (
      <DS.Frame style={styles.container} gap="16">
        {chapters?.map((chapter) => (
          <Chapter
            key={chapter._id}
            chapter={chapter}
            onPress={onChapterPress}
            isCurrentChapter={isCurrentChapter(chapter._id)}
            isVideoPlaying={isVideoPlaying}
            isUserSubscriber={isUserSubscriber}
          />
        ))}
      </DS.Frame>
    )
  }
)

const styles = StyleSheet.create({
  container: {
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 12,
    padding: 16,
    marginHorizontal: 24
  }
})
